import { getFormattedDateTime, getLocalizedMessage, showMessageAlert } from '@/core/shared'
import { bindResetButtonModal } from '@/core/input_controls/button/button'
import { setFocusOnField } from '@/core/core_components/form/form'

export function AttributesManager (companyId) {
	'use strict'

	this.companyId = companyId
	this.typeNames = {
		'ATTRIBUTES_GROUPS': getLocalizedMessage('attribute.type.attribute.groups'),
		'CLASSIFICATORS': getLocalizedMessage('attribute.type.classificators'),
		'DB_FILTER_ATTRIBUTES': getLocalizedMessage('attribute.type.db.filter.attributes'),
		'ITEM_ENRICHMENT': getLocalizedMessage('attribute.type.item.enrichment'),
		'ITEM_PK': getLocalizedMessage('attribute.type.item.pk'),
		'ITEM_STRUCTURE': getLocalizedMessage('attribute.type.item.structure'),
		'ITEM_VALIDATION_RULES': getLocalizedMessage('attribute.type.item.validation.rules'),
		'LANGUAGES': getLocalizedMessage('attribute.type.languages'),
		'MEASUREMENT_UNITS': getLocalizedMessage('attribute.type.measurement.units'),
		'TABLE_COLUMNS': getLocalizedMessage('attribute.type.table.columns'),
		'LOCALIZATION_MESSAGES': getLocalizedMessage('attribute.type.localization.messages'),
		'SEQUENCES': getLocalizedMessage('sequences')
	}
	this.download = undefined
	this.uploaded = undefined
	this.action = undefined
	this.activeAttribute = undefined
	this.postSaveAction = undefined
	this.prefix = undefined
	this.attribute = undefined

	this.setProperties = function (properties) {
		this.action = properties.action || 'create'
		this.notification = properties.notification || undefined
		this.activeAttribute = properties.activeAttribute || undefined
		this.prefix = properties.prefix || 'attribute_'
		this.postSaveAction = properties.postSaveAction
		this.download = properties.download
		this.uploaded = properties.uploaded
		this.attribute = properties.attribute
	}

	this.initTable = function (table) {
		this.updateAttributesTable(table)
	}

	this.initPage = function () {
		var attribute = this
		this.initTypes()
		this.clearAttributeInformation()

		if (this.action == 'edit') {
			this.setAttributeInformation()
			setFocusOnField(this.activeAttribute)
		}
		bindResetButtonModal()
	}

	this.initAttributesManager = function (action) {
		var attribute = this
		Swal.fire({
			title: getLocalizedMessage('attributes.config.title'),
			html: '<div class="modal_item">\n' +
				'    <label>' + getLocalizedMessage('attributes.config.type') + '</label>\n' +
				'    <br>\n' +
				'    <select id="attribute_type" class="select attribute-editor"></select>\n' +
				'</div>\n' +
				'<div class="modal_item">\n' +
				'    <label>' + getLocalizedMessage('configuration.file') + '</label>\n' +
				'    <div class="modal_item" id="attribute_file_group">\n' +
				'        <input id="attribute_file" type="file" accept=".json"/>\n' +
				'    </div>\n' +
				'    <div id="attribute_file_download" style="display: none"></div>\n' +
				'</div>',
			confirmButtonText: getLocalizedMessage('save'),
			showCancelButton: true,
			cancelButtonText: getLocalizedMessage('cancel'),
			buttonsStyling: false,
			allowOutsideClick: false,
			allowEnterKey: true,
			showClass: {
				popup: ''
			},
			hideClass: {
				popup: ''
			},
			customClass: {
				content: 'form',
				confirmButton: 'uk-button uk-button-primary uk-button-small uk-margin-small-right',
				cancelButton: 'uk-button uk-button-default uk-button-small',
			},
			onRender: function () {
				attribute.initPage()
			},
			preConfirm: function (inputValue) {
				var attributeModalData = {}
				attributeModalData.type = $('#attribute_type').val()
				attributeModalData.file = $('#attribute_file').get(0).files[0]
				return attributeModalData
			}
		}).then(function (result) {
			if (result.value) {
				attribute.saveAttribute(result.value.type, result.value.file)
			}
		})
	}

	this.setAttributeInformation = function () {
		var type = this.attribute['type']
		var attributeTypeSelector = $('#' + this.prefix + 'type')
		attributeTypeSelector.val(type)
		attributeTypeSelector.prop('disabled', 'disabled')

		var download = this.attribute['download']
		var fileDownloadSelector = $('#' + this.prefix + 'file_download')
		fileDownloadSelector.html(download)
		fileDownloadSelector.css('display', 'block')
	}

	this.clearAttributeInformation = function () {
		$('#' + this.prefix + 'type').prop('disabled', false)
		$('#attribute_file_group').find('input').val('')

		var fileDownloadSelector = $('#' + this.prefix + 'file_download')
		fileDownloadSelector.html('')
		fileDownloadSelector.css('display', 'none')
	}

	this.prepareData = function (data) {
		var manager = this
		_.each(data, function (value) {
			value['type_name'] = manager.typeNames[value['type']]
			value['uploaded'] = getFormattedDateTime(new Date(value['uploaded']))
		})
	}

	this.updateAttributesTable = function (table) {
		var manager = this
		$.ajax({
			type: 'GET',
			url: window.urlContext + 'company-attributes-config/' + manager.companyId + '/list',
			async: false,

			success: function (data) {
				_.each(data, function (value) {
					var url = '/company-attributes-config/' + manager.companyId + '/' + value.type.toLowerCase()
					value['download'] = '<a onclick="downloadManager(\'' + url + '\')">' + getLocalizedMessage('attributes.config.download') + '</a>'
				})
				table.setData(data)
				table.initTable()
			},
			error: function () {
				table.setData([])
				table.initTable()
			}
		})
	}

	this.initTypes = function () {
		var manager = this
		var listContent = ''
		var $list = $('#' + this.prefix + 'type')
		$list.empty()
		_.each(Object.keys(manager.typeNames), function (value) {
			listContent += '<option value=\'' + value + '\'>' + manager.typeNames[value] + '</option>'
		})
		$list.html(listContent)
	}

	this.saveAttribute = function (type, file) {
		var manager = this
		if (file) {
			var data = new FormData()
			data.append('source', file)

			$.ajax({
				url: window.urlContext + 'company-attributes-config/' + manager.companyId + '/' + type,
				data: data,
				cache: false,
				contentType: false,
				processData: false,
				type: 'POST',
				async: false,

				success: function () {
					if (manager.postSaveAction) {
						manager.postSaveAction()
					}
					showMessageAlert(getLocalizedMessage('changes.saved'), 'success')
				},
				error: function (jqXHR) {
					console.log(jqXHR)
					var message = getLocalizedMessage('error.saving')
					showMessageAlert(message, 'danger', jqXHR.responseText)
				}
			})
		}

	};
}
